<template>
  <div class="modal--addUser">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <p>
        {{ $t('For_the_role') }}: <span class="text-primary text-title">{{ data.for_obj.name }}</span>
      </p>
      <div v-if="data.users">
        <multiselect
          :close-on-select="false"
          :custom-label="firstNameWithLastName"
          :multiple="true"
          :options="data.users"
          :searchable="true"
          :show-labels="false"
          :placeholder="$t('please_chose_the_user')"
          track-by="user_id"
          v-model="selected_users"
        >
        </multiselect>
      </div>
    </div>

    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" round @click.native.prevent="addUsers">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
    <!--          End Buttons Part-->
  </div>
</template>

<script>
import CreateNewButton from '../buttons/CreateNewButton';
import Multiselect from 'vue-multiselect';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';

export default {
  name: 'AddUserModal',
  components: { SaveButton, CancelButton, CreateNewButton, Multiselect },
  props: {
    data: {},
  },
  data: function () {
    return {
      selected_users: null,
    };
  },
  methods: {
    closeModal: function () {
      this.selected_users = null;
      this.$emit('close');
    },
    // eslint-disable-next-line camelcase
    firstNameWithLastName: function ({ first_name, last_name }) {
      // eslint-disable-next-line camelcase
      return `${first_name} ${last_name}`;
    },
    addUsers: function () {
      this.$emit('submit', this.selected_users);
      this.closeModal();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped></style>
